import './profileSteps.scss';
import 'components/CreditCardComponents/CreditCardIbanSale/CreditCardIbanSale.scss';
// @ vendors
import React, { PureComponent } from 'react';
import cryptoJS from 'crypto-js';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
// @ components
import HeadlineTitle from 'componentsV2/HeadlineTitle/HeadlineTitle';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import { OpenCreditSale } from 'components/commons/openCreditSale/openCreditSale';
import { HTMLSafeInjector } from 'commonsComponents/htmlSafeInjector';
// @ actions
const formActions = require('react-redux-form').actions;
import preLoaderActions from 'actions/preLoaderActions';
import stepsActions from 'actions/stepsActions';
import standByActions from 'actions/standByActions';
import createActions from 'actions/createActions';
import cmsActions from 'actions/cmsActions';
import jointHoldersStatusActions from 'actions/jointHoldersStatusActions';
import { stopPolling } from 'actions/polling';
//@ utilities
import { FormattedText, formatText } from 'core/i18n';
import { recordEvent, recordCreateNewClient, PAGE_PRODUCT, recordEventStepSuccess } from 'utilities/uTagging';
// @constants
import { PATH_CREDIT_CARD, PATH_PROFESSION } from 'constants/uTagConstants/paths';
import { FIXED_PAYMENT_METHOD_VALUE, VARIABLE_PAYMENT_METHOD_VALUE } from 'utilities/paymentMethodHelper';
import { JAFFAR_TEXT, JAFFAR_TOOLTIP, NOMINA_TEXT, NO_NOMINA_TEXT } from 'constants/cms';
import { ERROR_AL_CREAR_CLIENTE } from 'constants/analyticsErrors';
import UtagHelper from 'utilities/utagHelper';
import { createClientWithConsent } from 'components/newAccountSteps/profileSteps/services/createClientWithConsent';
import consentsActions from 'actions/consentsActions';
import { goToErrorsView } from 'actions/errorViewNavigation';

class ProfileOpenCredit extends PureComponent {
    state = {
        isClicked: false,
    };

    UNSAFE_componentWillMount = () => {
        const { userProfile, formActions } = this.props;
        if (userProfile.creditCardOffer_accepted) {
            formActions.change('userProfile.openCreditJaffar', true);
        }
        window.scrollTo(0, 0);
    };

    componentDidMount = () => {
        const { cmsActions, userProfile, scorings, preLoaderActions } = this.props;
        const pensionista = '04';
        const cuentaAjena = '02';

        preLoaderActions.showPreLoader();

        if (scorings.getIn(['jaffar', 'scoringStatus']) === 'approved') {
            cmsActions.getCMS(JAFFAR_TEXT, JAFFAR_TOOLTIP);
            preLoaderActions.hidePreLoader();
        } else if (userProfile.accountType === pensionista || userProfile.accountType === cuentaAjena) {
            cmsActions.getCMSNotApproved(JAFFAR_TEXT, JAFFAR_TOOLTIP, NOMINA_TEXT);
            preLoaderActions.hidePreLoader();
        } else {
            cmsActions.getCMSNotApproved(JAFFAR_TEXT, JAFFAR_TOOLTIP, NO_NOMINA_TEXT);
            preLoaderActions.hidePreLoader();
        }
    };

    componentWillUnmount = () => {
        const { formActions } = this.props;
        formActions.resetValidity('userProfile.paymentMethodType');
        formActions.resetValidity('userProfile.fixedPaymentMethodValue');
        formActions.resetValidity('userProfile.variablePaymentMethodValue');
        stopPolling();
    };

    onPrevious = () => {
        const { formActions } = this.props;
        window.scrollTo(0, 0);
        formActions.change('userProfile.showOpenCredit', false);
    };

    gotoNextStep = () => {
        const { actions, immStepsState } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = this.props.immStepsState.get('readOnlyForms');

        this.setState({ isClicked: false });

        if (!disabled) {
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }
    };

    getRequiredFields = () => {
        const { userProfile } = this.props;
        let requiredFields = [];

        const paymentMethodType = userProfile.paymentMethodType;
        requiredFields = requiredFields.concat(['paymentMethodType']);
        switch (paymentMethodType) {
            case FIXED_PAYMENT_METHOD_VALUE:
                requiredFields = requiredFields.concat(['fixedPaymentMethodValue']);
                break;
            case VARIABLE_PAYMENT_METHOD_VALUE:
                requiredFields = requiredFields.concat(['variablePaymentMethodValue']);
                break;
            default:
                break;
        }

        return requiredFields;
    };

    onHandleValidateFields = () => {
        const { userProfile, formActions } = this.props;
        let requiredFlag = true;
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const creditCardChecked = userProfile.creditCardOffer_accepted;
        if (!disabled && creditCardChecked) {
            const requiredFields = this.getRequiredFields();
            // Parse validations
            for (let i = 0; i < requiredFields.length; i++) {
                const field = userProfile[requiredFields[i]];
                if (!field) {
                    formActions.setValidity(`userProfile.${requiredFields[i]}`, { required: false });
                    requiredFlag = false;
                }
            }
        }

        if (!creditCardChecked) {
            formActions.change('userProfile.openCreditJaffar', false);
        }

        return requiredFlag;
    };

    handleShowNonExclusiveModal = () => {
        this.setState({ showModalNonExclusiveKO: true, blowupClass: 'blowup-modal blowup-in' });
    };

    createClient = () => {
        const {
            userProfile,
            actions,
            createActions,
            consentsActions,
            immStepsState,
            preLoaderActions,
            goToErrorsView,
        } = this.props;
        const { recordId, product, promoCode, investmentType, docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const accessToken = userProfile.accessToken;
        const currentIndex = immStepsState.get('currentStep');
        const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        preLoaderActions.showPreLoader();
        const finishAction = () => {
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
            preLoaderActions.hidePreLoader();
            this.gotoNextStep();
        };
        const onCreateClient = userId => {
            recordEvent(
                PATH_PROFESSION,
                PAGE_PRODUCT,
                'tu actividad',
                'tu actividad correcto',
                recordId,
                userId,
                '',
                investmentType ? investmentType : '',
                docNumberEncrypted
            );
            recordEventStepSuccess(investmentType, '/onboarding/tu-actividad/', 'tu actividad');
            recordCreateNewClient(
                recordId,
                userId,
                product,
                promoCode ? promoCode : '',
                '',
                '',
                investmentType ? investmentType : '',
                jointHolderInfo
            );
        };
        const onError = () => {
            goToErrorsView({ errorMessage: ERROR_AL_CREAR_CLIENTE });
            preLoaderActions.hidePreLoader();
        };
        createClientWithConsent({ createActions, consentsActions }, accessToken, onCreateClient, finishAction, onError);
    };

    checkboxEvent = () => {
        const { userProfile } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        if (userProfile.creditCardOffer_accepted) {
            recordEvent(
                PATH_CREDIT_CARD,
                PAGE_PRODUCT,
                'tarjeta de credito checkbox',
                'tarjeta de credito checkbox checkeado',
                '',
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );
        } else {
            recordEvent(
                PATH_CREDIT_CARD,
                PAGE_PRODUCT,
                'tarjeta de credito checkbox',
                'tarjeta de credito checkbox no checkeado',
                '',
                '',
                '',
                userProfile.investmentType,
                docNumberEncrypted
            );
        }
    };

    onContinue = () => {
        const { userProfile, actions, immStepsState, jointHoldersStatusActions, preLoaderActions, standByActions } =
            this.props;
        const accessToken = userProfile.accessToken;
        const disabled = immStepsState.get('readOnlyForms');
        const valid = this.onHandleValidateFields();
        const currentIndex = immStepsState.get('currentStep');
        let clicked = true;

        if (valid && !disabled) {
            actions.clientVerifyOk(accessToken, verifiedOk => {
                actions.clientFiocVerify(accessToken, (verified, data) => {
                    if (verifiedOk && verified) {
                        this.createClient();
                    } else {
                        if (data['0301']) {
                            preLoaderActions.showPreLoader();
                            this.props.actions.changeMinFinalizeStep({ index: 0 });
                            this.props.actions.finalizeStep({
                                index: currentIndex,
                                finished: true,
                            });
                            jointHoldersStatusActions.statusHolders(accessToken);
                            standByActions.showStandByJointHolders(true);
                        } else {
                            this.handleShowNonExclusiveModal();
                        }
                        if (userProfile.jointHolderDecision === 'true') {
                            standByActions.showStandByJointHolders(true);
                        }
                        preLoaderActions.hidePreLoader();
                        clicked = false;
                    }
                });
            });
        } else if (disabled) this.gotoNextStep();
        else clicked = false;

        this.setState({ isClicked: clicked });
        this.checkboxEvent();
    };

    onHandleDisableNextButton = value => this.setState({ isClicked: value });

    getOpenCredit = () => {
        const { cms, scorings } = this.props;
        const title = formatText('CMS-notNominaTC');
        const setLimit = scorings.getIn(['jaffar', 'cardLimit']);
        let format = null;
        let text = formatText('CMS-jaffarTCText');
        let tooltip = <FormattedText value="CMS-jaffarTCTooltip" />;

        if (scorings.getIn(['jaffar', 'scoringStatus']) === 'approved') {
            if (cms.getIn(['cmsPostFiocApproved', 'text']) && cms.getIn(['cmsPostFiocApproved', 'tooltip'])) {
                format =
                    cms.getIn(['cmsPostFiocApproved', 'text']) &&
                    cms.getIn(['cmsPostFiocApproved', 'text']).replace(/p>/g, 'span>');
                text = format && <HTMLSafeInjector message={format} inline={true} />;
                tooltip = cms.getIn(['cmsPostFiocApproved', 'tooltip']) && (
                    <HTMLSafeInjector message={cms.getIn(['cmsPostFiocApproved', 'tooltip'])} />
                );
            }
        } else if (
            cms.getIn(['cmsPostFiocNotApproved', 'text']) &&
            cms.getIn(['cmsPostFiocNotApproved', 'tooltip']) &&
            cms.getIn(['cmsPostFiocNotApproved', 'title'])
        ) {
            format =
                cms.getIn(['cmsPostFiocNotApproved', 'text']) &&
                cms.getIn(['cmsPostFiocNotApproved', 'text']).replace(/p>/g, 'span>');
            text = format && <HTMLSafeInjector message={format} inline={true} />;
            tooltip = cms.getIn(['cmsPostFiocNotApproved', 'tooltip']) && (
                <HTMLSafeInjector message={cms.getIn(['cmsPostFiocNotApproved', 'tooltip'])} />
            );
        }

        return (
            <OpenCreditSale
                handleDisableNextButton={this.onHandleDisableNextButton}
                limit={setLimit}
                CMSText={text}
                CMSTooltip={tooltip}
                title={title}
                tagPath={PATH_CREDIT_CARD}
            />
        );
    };

    render = () => {
        const openCredit = this.getOpenCredit();
        const openCreditClass = classnames('openCredit-container');

        return (
            <div className="prospects-step-content basic-layering">
                <HeadlineTitle />
                <section className={openCreditClass}>{openCredit}</section>
                <div className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonPrevSpecialHidden={true}
                            buttonPrevHidden={true}
                            buttonPrevAction={this.onPrevious}
                            buttonContinueAction={this.onContinue}
                            buttonContinueDisabled={this.state.isClicked}
                        />
                    </div>
                </div>
            </div>
        );
    };
}

module.exports.constructor = ProfileOpenCredit;
module.exports.ProfileOpenCredit = connect(
    state => ({
        userProfile: state.userProfile,
        immStepsState: state.steps,
        cms: state.cms,
        scorings: state.scorings,
        immStandByState: state.standBy,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        createActions: bindActionCreators(createActions, dispatch),
        cmsActions: bindActionCreators(cmsActions, dispatch),
        jointHoldersStatusActions: bindActionCreators(jointHoldersStatusActions, dispatch),
        standByActions: bindActionCreators(standByActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
    })
)(ProfileOpenCredit);
